import { render, staticRenderFns } from "./appOrder.vue?vue&type=template&id=5d7a3f88&scoped=true&"
import script from "./appOrder.vue?vue&type=script&lang=js&"
export * from "./appOrder.vue?vue&type=script&lang=js&"
import style0 from "./appOrder.vue?vue&type=style&index=0&id=5d7a3f88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a3f88",
  null
  
)

export default component.exports